import React from 'react'
import Slider from '../slides/Slider'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'


const Playlists = (props) => {

  const navigate = useNavigate()

  const {userPlaylistsError, userPlaylistloading, userPlaylists } = useSelector(state => state.userPlaylists)


  return (
    <div className="col-12" style = {{ marginBottom:"2.5vw"}}>
      {
      userPlaylists && userPlaylists.length ?
      <>
          {
            userPlaylistloading ? <div>Loading...</div> :
            userPlaylistsError ? <h3>{userPlaylistsError}</h3> :
                <Slider
                    num = {5}
                    type = {1}
                    tvData={userPlaylists}
                    slideClickHandler = {props.slideClickHandler}
                    showTitle = {true}
                    slideTitle = {"My Playlists"}
                    showAllHandler = {()=>navigate('/myPlaylists')}
                />
          } </>: "" 
      }
    </div>
  )
}

export default Playlists;

